import { render } from "./OpeningHours.vue?vue&type=template&id=418ede90&scoped=true&ts=true"
import script from "./OpeningHours.vue?vue&type=script&lang=ts"
export * from "./OpeningHours.vue?vue&type=script&lang=ts"

import "./OpeningHours.vue?vue&type=style&index=0&id=418ede90&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418ede90"]])

export default __exports__